import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
 
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //skip token handling logic if it is login API
    const excludeUrls = ['api/BcpJwtAuth/login'
      , 'api/BcpJwtAuth/getDefaultLogin', 'api/BcpJwtAuth/renewToken'
      , 'api/BcpJwtAuth/getDatabase', 'api/BcpJwtAuth/getEnvironment'
      , 'api/BcpJwtAuth/changePwd','api/BcpEmailService/SendVerifyCode'];

    // Check if the request URL is in the list of login URLs
    const isExcludeRequest = excludeUrls.some(url => request.url.includes(url));

    if (isExcludeRequest) {
      console.log("Bypass Token Check for API call : " + request.url);
      return next.handle(request);
    }  

    //console.log("bypass for API call : " + request.url);
    return this.authService.getToken().pipe(
      switchMap(token => {
        let modifiedRequest: HttpRequest<any>;

        if (token) {
          // Always add the Authorization header with the token from AuthService
          console.log("Append Token : " + token);
          modifiedRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          //console.log("Interceptor : " + request.url);
          //console.log("Interceptor - add token " + token);
          this.authService.setSessionTimeout();
        } else {
          // If no token, do NOT proceed.  This is the key change.
          console.error("AuthInterceptor: No token available.  Request blocked.");
          return throwError({ status: 401, statusText: 'unauthorized' }); // Or some other appropriate error
        }

        return next.handle(modifiedRequest);
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.authService.clearAuthData();
        }
        return throwError(err);
      })
    );
  }
}
